import React from 'react'

type CustomProps = {
  label: string;
  isRightLabel?: boolean;
  isLeftLabel?: boolean;
  inputClassName?: string;
}

type ComponentProps = CustomProps &
  React.InputHTMLAttributes<HTMLInputElement>;

const CheckboxCircleControl: React.FC<ComponentProps> = ({
  isRightLabel = false,
  isLeftLabel = true,
  inputClassName = '',
  label,
  ...inputProps
}) => {
  return (
    <label className={`flex text-nowrap flex-row gap-x-2 cursor-pointer select-none items-center ${inputProps.className}`} >
      {isLeftLabel && label}
      <div className="relative">
        <input
          {...inputProps}
          type="checkbox"
          className={`sr-only ${inputClassName}`}
        />
        <div
          className={`box mr-4 flex h-4 w-4 items-center justify-center rounded-full border border-primary ${inputProps.checked && '!border-4'
          }`}
        >
          <span className="h-2 w-2 rounded-full bg-white dark:bg-transparent" />
        </div>
      </div>
      {isRightLabel && label}
    </label>
  )
};

export default CheckboxCircleControl;
